import { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 3 PRO React components
import MDInput from "components/MDInput";

import FormSelect from "components/DigiHapi/FormSelect";

import {
	fetchGetAddressUsingZipCode,
	fetchGetCityUsingZipCode,
	fetchGetAddressUsingCoordinates
} from "actions/datagouv";

import {
	SET_NEIGHBORHOOD_ADDRESS,
	SET_NEIGHBORHOOD_CITY,
	SET_NEIGHBORHOOD_ZIP_CODE,
	SET_NEIGHBORHOOD_SELECTED_CITY,
	SET_NEIGHBORHOOD_SELECTED_ADDRESS,
	SET_NEIGHBORHOOD_SELECTED_ZIPCODE,
	SET_NEIGHBORHOOD_BUILDING,
	SET_NEIGHBORHOOD_RESIDENCE,
	SET_NEIGHBORHOOD_DISTRICT
} from "actions/types";

const OTHER = "Autre ...";

// Select options built from the keys of the datagouv results
const toOptions = data =>
	Object.keys(data || {}).map(key => ({ value: key, label: key }));

class Step2 extends Component {
	sendState() {
		return this.state;
	}

	isValidated() {
		return true;
	}

	render() {
		const {
			dispatch,
			customAddress,
			address,
			addresses,
			selectedAddress,
			addressUpdated,
			zipCodes,
			selectedZipCode,
			customZipCode,
			zipCode,
			zipCodeUpdated,
			cities,
			selectedCity,
			customCity,
			longitude,
			latitude,
			building,
			residence,
			district
		} = this.props;
		return (
			<Grid container spacing={3} justifyContent="center">
				{selectedAddress === OTHER ? (
					<Grid item xs={12}>
						<MDInput
							label="Adresse"
							id="address"
							fullWidth
							value={customAddress ? customAddress : ""}
							onChange={e =>
								dispatch({
									type: SET_NEIGHBORHOOD_ADDRESS,
									value: e.target.value
								})
							}
							onBlur={() => {
								if (addressUpdated && address) {
									if (zipCode) {
										this.props.fetchGetAddressUsingZipCode({
											address,
											zipCode
										});
									} else if (longitude && latitude) {
										this.props.fetchGetAddressUsingCoordinates({
											address,
											latitude,
											longitude
										});
									}
								}
							}}
						/>
					</Grid>
				) : (
					<Grid item xs={12}>
						<FormSelect
							label="Adresse"
							value={selectedAddress}
							placeholder={OTHER}
							placeholderSelectable
							options={toOptions(addresses)}
							onChange={(e, child) =>
								dispatch({
									type: SET_NEIGHBORHOOD_SELECTED_ADDRESS,
									payload: child.props.children
								})
							}
						/>
					</Grid>
				)}
				{selectedZipCode === OTHER ? (
					<Grid item xs={12} md={6}>
						<MDInput
							label="Code postal"
							id="zipcode"
							fullWidth
							value={customZipCode ? customZipCode : ""}
							onChange={e =>
								dispatch({
									type: SET_NEIGHBORHOOD_ZIP_CODE,
									value: e.target.value
								})
							}
							onBlur={() =>
								zipCodeUpdated &&
								zipCode &&
								this.props.fetchGetCityUsingZipCode({ address, zipCode })
							}
						/>
					</Grid>
				) : (
					<Grid item xs={12} md={6}>
						<FormSelect
							label="Code postal"
							value={selectedZipCode}
							placeholder={OTHER}
							placeholderSelectable
							options={toOptions(zipCodes)}
							onChange={(e, child) =>
								dispatch({
									type: SET_NEIGHBORHOOD_SELECTED_ZIPCODE,
									payload: child.props.children
								})
							}
						/>
					</Grid>
				)}
				{selectedCity === OTHER ? (
					<Grid item xs={12} md={6}>
						<MDInput
							label="Ville"
							id="city"
							fullWidth
							value={customCity ? customCity : ""}
							onChange={e =>
								dispatch({
									type: SET_NEIGHBORHOOD_CITY,
									value: e.target.value
								})
							}
						/>
					</Grid>
				) : (
					<Grid item xs={12} md={6}>
						<FormSelect
							label="Ville"
							value={selectedCity}
							placeholder={OTHER}
							placeholderSelectable
							options={toOptions(cities)}
							onChange={(e, child) =>
								dispatch({
									type: SET_NEIGHBORHOOD_SELECTED_CITY,
									payload: child.props.children
								})
							}
						/>
					</Grid>
				)}
				<Grid item xs={12} md={6}>
					<MDInput
						label="Bâtiment"
						id="building"
						fullWidth
						value={building ? building : ""}
						onChange={e =>
							dispatch({
								type: SET_NEIGHBORHOOD_BUILDING,
								value: e.target.value
							})
						}
					/>
				</Grid>
				<Grid item xs={12} md={6}>
					<MDInput
						label="Résidence"
						id="residence"
						fullWidth
						value={residence ? residence : ""}
						onChange={e =>
							dispatch({
								type: SET_NEIGHBORHOOD_RESIDENCE,
								value: e.target.value
							})
						}
					/>
				</Grid>
				<Grid item xs={12}>
					<MDInput
						label="Quartier"
						id="district"
						fullWidth
						value={district ? district : ""}
						onChange={e =>
							dispatch({
								type: SET_NEIGHBORHOOD_DISTRICT,
								value: e.target.value
							})
						}
					/>
				</Grid>
			</Grid>
		);
	}
}

const mapStateToProps = state => {
	const {
		_id,
		isFetching,
		isFetchingList,
		name,
		nameErrorMsg,
		addressUpdated,
		customAddress,
		addresses,
		selectedAddress,
		address,
		customZipCode,
		zipCodes,
		selectedZipCode,
		zipCode,
		zipCodeUpdated,
		customCity,
		city,
		selectedCity,
		cities,
		latitude,
		longitude,
		registerkey,
		building,
		residence,
		district
	} = state.neighborhoodReducer;
	return {
		_id,
		isFetching,
		isFetchingList,
		name,
		nameErrorMsg,
		address,
		customAddress,
		addresses,
		selectedAddress,
		addressUpdated,
		zipCode,
		customZipCode,
		zipCodes,
		selectedZipCode,
		zipCodeUpdated,
		customCity,
		city,
		selectedCity,
		cities,
		latitude,
		longitude,
		registerkey,
		building,
		residence,
		district
	};
};

const mapDispatchToProps = dispatch => {
	let actions = bindActionCreators(
		{
			fetchGetAddressUsingZipCode,
			fetchGetCityUsingZipCode,
			fetchGetAddressUsingCoordinates
		},
		dispatch
	);
	return { ...actions, dispatch };
};
export default connect(mapStateToProps, mapDispatchToProps, null, {
	forwardRef: true
})(Step2);
